var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "container-fluid mt-3 bg-white" }, [
    _c("div", { staticClass: "row h-100 no-gutters pt-5" }, [
      _c("div", { staticClass: "col-12 mx-lg-auto p-0" }, [
        _c(
          "div",
          {
            staticClass:
              "row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
          },
          [
            _c(
              "div",
              { staticClass: "col-12 col-xl-2 col-md-3 pt-lg-6 border-right" },
              [_c("pc-side-nav")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-lg mb-3 mb-lg-5 pt-6" },
              [
                _c("pc-my-projects-conatiner", {
                  staticClass: "pc-my-trays-pages",
                  attrs: { isAdmin: _vm.user.isAdmin }
                })
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }